import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AiOutlineSearch } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import s from './style.css';
import { vault } from '../../actions';
import { API } from '../../actions/URL';
const mapDispatchToProps = {
    ...vault,
};
const connector = connect(null, mapDispatchToProps);
const SearchBar = (props) => {
    const [text, setText] = useState('');
    const history = useHistory();
    const handleKeydown = (event) => {
        if (text === '')
            return;
        if (event.key === 'Enter') {
            history.push('/vault/files');
            props.searchItems(`${API}/api/search-files/?q=${text}&limit=15`, true);
        }
    };
    useEffect(() => {
        const keydownListener = (event) => handleKeydown(event);
        document.addEventListener('keydown', keydownListener);
        return () => {
            document.removeEventListener('keydown', keydownListener);
        };
    }, [text]);
    const onChange = (e) => {
        setText(e.target.value);
    };
    return (React.createElement("div", { className: s.container },
        React.createElement(AiOutlineSearch, { color: 'grey', size: 20 }),
        React.createElement("input", { value: text, className: s.input, placeholder: 'Search files...', onChange: onChange }),
        React.createElement(IoClose, { onClick: () => setText(''), color: text === '' ? '#f3f3f3' : 'grey', size: 20 })));
};
export default connector(SearchBar);
